import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** Statuses whose received cash is unapplied voided-order cash rather than an owed amount. */
export const AR_VOIDED_STATUSES = [
    SalesOrderStatus.CANCELLED,
    SalesOrderStatus.REJECTED,
];
//# sourceMappingURL=ar-voided-statuses.js.map